import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TradingTransferState } from "./types";

const initialState: TradingTransferState = {
    isTransferBonusesModalOpen: false,
    onTransfer: null
}

interface OpenTransferBonusesModal {
    onTransfer?: () => void
}

const tradingTransferSlice = createSlice({
    name: 'tradingTransfer',
    initialState,
    reducers: {
        openTransferBonusesModal: (state, action: PayloadAction<OpenTransferBonusesModal>) => {
            state.onTransfer = action.payload.onTransfer ?? null
            state.isTransferBonusesModalOpen = true
        },
        closeTransferBonusesModal: (state) => {
            state.isTransferBonusesModalOpen = false
        }
    },
})

export default tradingTransferSlice.reducer
export const { closeTransferBonusesModal, openTransferBonusesModal } = tradingTransferSlice.actions
